export const SET_LOADING = 'rewards/prizes/set_loading';

export const SET_PRIZES = 'rewards/prizes/set_prizes';
export const UPDATE_PRIZE = 'rewards/prizes/update_prize';
export const CREATE_PRIZE = 'rewards/prizes/create_prize';
export const DELETE_PRIZE = 'rewards/prizes/delete_prize';

export const SET_TEMPLATES = 'rewards/prizes/set_templates';
export const UPDATE_TEMPLATE = 'rewards/prizes/update_template';
export const CREATE_TEMPLATE = 'rewards/prizes/create_template';

export const UPDATE_PRIZE_LOCALLY = 'rewards/prizes/update_prize_locally';

export const SET_STORE_OPEN = 'rewards/prizes/set_store_open';



// WEBPACK FOOTER //
// ./src/store/rewards/prizes/types.js